import React from 'react';
export default function Hit({ hit }) {
    return (React.createElement(React.Fragment, null, JSON.stringify(hit)));
}
